module.exports = __webpack_public_path__ + "img/prayer-journal_B095GRZTZ1.b6535c9b.jpg";